import React from 'react';
import {useFormikContext, FieldArray} from 'formik';
import {Button, Icon, Input, Textarea} from '../UI';
import { FormValues } from '../../common/interfaces';
import {MaskedInput} from '../UI/MaskedInput';

export const TicketsAndAccidents = () => {
  const { values } = useFormikContext<FormValues>();

  return (
    <FieldArray name="incidents">
      {({ push, remove }) => (
        <div className="space-y-4">
          {values.incidents.map((_, index) => (
            <div key={index} className="flex items-end">
              <span className="w-10 text-slate-500 font-semibold">{index + 1}.</span>

              <div className="w-full grid grid-cols-2 gap-6">
                <MaskedInput name={`incidents.${index}.date`} label="Date" mask='99/99/9999' />
                <Input name={`incidents.${index}.description`} label="Description" />
                <div className='col-span-2'>
                  <Textarea name={`incidents.${index}.injuries`} label="Injuries / Fatalities" />
                </div>
              </div>

              {values.incidents.length > 1 && (
                <Button onClick={() => remove(index)}>
                  <Icon prefix='fal' icon='trash-alt' />
                </Button>
              )}
            </div>
          ))}

          <div className="flex justify-end">
            <Button
              type="button"
              size='xs'
              onClick={() => push({ date: '', description: '', injuries: '' })}
            >
              + Add Incident
            </Button>
          </div>
        </div>
      )}
    </FieldArray>
  );
};